/**
 * @generated SignedSource<<b45584fcdcd95c820eac632593a7a514>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NoteDeleteMutation$variables = {
  id: number;
};
export type NoteDeleteMutation$data = {
  readonly deleteNote: {
    readonly project: {
      readonly id: number;
      readonly notes: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly notes_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
    } | null | undefined;
  };
};
export type NoteDeleteMutation = {
  response: NoteDeleteMutation$data;
  variables: NoteDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DeleteNoteResult",
    "kind": "LinkedField",
    "name": "deleteNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "order_by",
                "value": {
                  "created_at": "asc"
                }
              }
            ],
            "concreteType": "notes",
            "kind": "LinkedField",
            "name": "notes",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": "notes(order_by:{\"created_at\":\"asc\"})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "notes_aggregate",
            "kind": "LinkedField",
            "name": "notes_aggregate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "notes_aggregate_fields",
                "kind": "LinkedField",
                "name": "aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4093f91beef035f0007cb47348292ff7",
    "id": null,
    "metadata": {},
    "name": "NoteDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation NoteDeleteMutation(\n  $id: Int!\n) {\n  deleteNote(id: $id) {\n    project {\n      id\n      notes(order_by: {created_at: asc}) {\n        id\n      }\n      notes_aggregate {\n        aggregate {\n          count\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36f64df779a896fe6290217210ee6cc9";

export default node;
